import axios from 'axios'
import store from '../store'
global.antRoutsssser = '' // 全局的路由
// 服务器的资源地址 https://active.jhtwl.com/yunactive/  ，发布时可用    ./ 代表本地路径地址
// 本地资源位置
global.domain = 'https://www.myzctd.com.cn/yunactive/uploads/'
global.domain1 = 'http://127.0.0.1:8080/'
// ajax请的地址
// 服务器发布地址 https://active.jhtwl.com/tomcat/kjyunghost/
// 本地开发地址   http://127.0.0.1:8080/
// 发布修改 1项/总1项
global.ajaxPath = 'https://www.myzctd.com.cn/tomcat/kjyunghost/'
global.ajaxPath1 = '/api' // 'http://127.0.0.1:8080/'
//

global.token = ''
global.timeout = 20000
global.timestamp = function () {
  return new Date().getTime()
}

global.capitalize = function (value) {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
}
global.formatDate = function (value, fmt) {
  var date = new Date(value)
  if (typeof (fmt) === 'undefined') {
    fmt = 'yyyy-MM-dd HH:mm:ss'
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  let o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'H+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  }
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + ''
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : ('00' + str).substr(str.length))
    }
  }
  return fmt
}
global.http = function (vurl, vdata, funSuccess, funFaile) {
  if (funFaile === undefined || funFaile === null) {
    funFaile = function (err) {
      console.log(err)
    }
  }
  var token = ''
  var vheader = {
    // "X-Requested-with": "XMLHttpRequest",
    'Content-Type': 'application/json; charset=UTF-8'
  }

  var instance = axios.create({
    // http://127.0.0.1:8080/test/getTest0
    baseURL: global.ajaxPath, // '/api',    //'https://dev.sushukj.com/tomcat/kjyunghost',  //  /api
    // withCredentials : true, //不能使用，又完全开放域
    responseType: 'json',
    method: 'post',
    timeout: 1000 * 60 * 10
  })

  instance.interceptors.request.use(config => {
    // 在发送请求前做一些事    config.headers['Content-Type'] = 'application/json; charset=UTF-8'
    if (store != null && store.state.token != null && store.state.token != undefined) {
      token = store.getters.getStorage
      if (token != null && token != undefined && token != '') {
        // 加拦截器
        config.headers.common['Authorization'] = token
      }
    }
    return config
  }, err => {
    // 在请求错误时做的事儿
    console.log('=======axios err=====')
    console.log(err)
    return Promise.reject(err)
  })

  instance
    .post(vurl, vdata)
    .then(rsp => {
      var obj = rsp.data
      funSuccess(obj)
    })
    .catch(err => {
      funFaile(err)
    })
}
global.http2 = function (vurl, vdata) {

  // 保留原有默认失败处理逻辑
  const defaultFailHandler = function (err) {
    console.log(err)
  }

  // 返回 Promise 对象，支持异步调用
  return new Promise((resolve, reject) => {
    var token = ''
    var vheader = {
      'Content-Type': 'application/json; charset=UTF-8'
    }

    var instance = axios.create({
      baseURL: global.ajaxPath,
      responseType: 'json',
      method: 'post',
      timeout: 1000 * 60 * 10
    })

    // 保留请求拦截器逻辑（完整迁移）
    instance.interceptors.request.use(config => {
      // 在发送请求前做一些事
      config.headers['Content-Type'] = 'application/json; charset=UTF-8'
      if (store != null && store.state.token != null && store.state.token != undefined) {
        token = store.getters.getStorage
        if (token != null && token !== undefined && token !== '') {
          // 加拦截器
          config.headers.common['Authorization'] = token
        }
      }
      return config
    }, err => {
      // 在请求错误时做的事儿
      console.log('=======axios err=====')
      console.log(err)
      return Promise.reject(err)
    })

    // 发送请求并处理结果
    instance
      .post(vurl, vdata)
      .then(rsp => {
        var obj = rsp.data
        // 成功时 resolve 返回数据
        resolve(obj)
      })
      .catch(err => {
        // 执行默认失败处理
        defaultFailHandler(err)
        // 失败时 reject 抛出错误
        reject(err)
      })
  })
}
global.checkFileExName = function (fileEx, listEx) {
  // console.log(listEx)
  // console.log(fileEx)
  var ret = false
  listEx.forEach(function (value, index, array) {
    if (value === fileEx) { ret = true }
  })
  return ret
}
// 返回参数表
global.getUrlParas = function (vurl) {
  let arr = vurl.split('?')
  let params = arr[1].split('&')
  let obj = {}
  for (let i = 0; i < params.length; i++) {
    let param = params[i].split('=')
    obj[param[0]] = param[1]
  }
  return obj
}



// WEBPACK FOOTER //
// ./src/utils/global.js